import {Course, User} from "models"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import {addCreateAuditColumnIfAdmin} from "components/audits/create-audit-column"
import ApiMakerTable from "shared/api-maker-table"
import classNames from "classnames"
import CourseLink from "components/courses/link"
import linkProps from "shared/link-props"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"

/**
 * @typedef {object} ComponentsCoursesProps
 * @property {unknown} adminLayout
 * @property {string} className
 * @property {User} currentUser
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsCoursesState */

/**
 * @extends {ShapeComponent<ComponentsCoursesProps, ComponentsCoursesState>}
 */
class ComponentsCourses extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    currentUser: PropTypes.instanceOf(User),
    userLayout: PropTypes.bool.isRequired
  }

  setup() {
    this.currentUser = useCurrentUser()
  }

  render() {
    const {columns, editModelPath, viewModelPath} = this.tt
    const {adminLayout, className, userLayout, ...restProps} = this.props

    return (
      <ApiMakerTable
        className={classNames("components--courses--table", className)}
        columns={columns}
        editModelPath={editModelPath}
        modelClass={Course}
        select={{Course: ["id", "name"]}}
        viewModelPath={viewModelPath}
        {...restProps}
      />
    )
  }

  columns = () => {
    const columns = [
      {
        attribute: "id",
        defaultVisible: false,
        sortKey: "id"
      },
      {
        content: this.tt.courseContent,
        label: Course.humanAttributeName("name"),
        sortKey: "currentTranslationName"
      },
      {
        attribute: "public",
        sortKey: "public"
      },
      {
        attribute: "randomContent",
        sortKey: "randomContent"
      },
      {
        attribute: "valuePoints",
        sortKey: "valuePoints"
      }
    ]

    addCreateAuditColumnIfAdmin(this.props, columns, this.tt.currentUser)

    return columns
  }

  editModelPath = ({course}) => {
    const {adminLayout} = this.p

    if (adminLayout) return Routes.editAdminCoursePath(course.id())
  }

  viewModelPath = ({course}) => {
    const {adminLayout} = this.p

    if (adminLayout) return Routes.adminCoursePath(course.id())
  }

  courseContent = ({course}) => <CourseLink course={course} {...linkProps(this.props)} />
}

export default React.memo(shapeComponent(ComponentsCourses))
